export enum LoadingIndicator {
    hidden = 1,
    dialog = 2,
    snackbar = 3,
}

export interface AcumaticaLoadingOptions {
    // string message to display on loading indicator
    message?: string | null;
    // type of loading indicator to display
    indicator?: LoadingIndicator;
    // delay closing of the delay indicator by delayClose ms
    delayClose?: number;
}